import React from "react";
import ModalComponent from "@/components/modal";
import { Divider, Flex, Popover } from "antd";
import { openLinkInNewTab } from "@/helpers";
import IconDots from "@/components/icons/IconDots";
import IconPen from "@/components/icons/IconPen";
import { setCurrentForm, setFormProps, setModalOpen } from "@/reducers/commonSlice";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { updateFile } from "@/services/users/updateFile";
import truncate from "lodash/truncate";

const ViewDocument = ({ isOpen, title = "", files = [], fetchData }) => {
  const dispatch = useDispatch();
  const content = ({ fileData }) => {
    console.log(fileData, "fileData");
    return (
      <div className="menulink-popover">
        <Link
          onClick={(event) => {
            event.stopPropagation();
            dispatch(setCurrentForm("dashboardDocuments"));
            dispatch(setModalOpen(true));
            dispatch(
              setFormProps({
                onSubmit: (value) => {
                  const file = value.file[0]?.originFileObj;
                  const formData = new FormData();
                  formData.append("file", file);
                  updateFile(value.fileid, formData)
                    .then((res) => {
                      dispatch(setModalOpen(false));
                      fetchData();
                    })
                    .catch((error) => console.log(error));
                  // const comment = value.comment;
                  // formData.append("comment", comment);
                  // addStudentTaskDocumentById(id, formData)
                  //   .then((res) => {
                  //     dispatch(setModalOpen(false));
                  //     fetchData();
                  //   })
                  //   .catch((error) => console.log(error));
                },
                limit: 1,
                fileData: fileData,
              })
            );
          }}
        >
          <Flex align="center" gap="0.5rem" className="color-brand">
            <span className="flex">
              <IconPen />
            </span>
            <span>Edit Document</span>
          </Flex>
        </Link>
      </div>
    );
  };

  return (
    <ModalComponent isOpen={isOpen} width={347} closeIcon>
      <Flex vertical gap="1rem" align="start">
        <div className="body-b1">{title}</div>
        <Divider style={{ margin: "0 0" }} />
        <Flex gap="1rem" wrap style={{ width: "100%" }}>
          {files.map((x, i) => {
            return (
              <Flex className="file-chip cursor-pointer" key={i}>
                <div
                  style={{
                    padding: "4px 8px 4px 8px",
                    backgroundColor: "#FFF5F0",
                    borderRadius: "5px",
                    display: "flex",
                    gap: "5px",
                    alignItems: "center",
                  }}
                  onClick={() => openLinkInNewTab(x.signedUrl)}
                >
                  <span>{truncate(x?.fileName, { length: 30 })}</span>
                  <Popover
                    placement="bottomRight"
                    content={content({
                      fileData: x,
                    })}
                    // open={openId === index}
                    trigger="click"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <IconDots className="cursor-pointer" on />
                  </Popover>
                </div>
              </Flex>
            );
          })}
        </Flex>
      </Flex>
    </ModalComponent>
  );
};

export default ViewDocument;
